module.exports = __webpack_public_path__ + "static/media/ios-cloudy.f7bf5d2a.svg";